import React, { createContext, useContext } from 'react';
export type RankingLayout = 'list' | 'grid';
interface SiteSettings {
  showRealMoneyCtas: boolean;
  rankingLayout: RankingLayout;
}
const SiteSettingsContext = createContext<SiteSettings>({
  showRealMoneyCtas: true,
  rankingLayout: 'list'
});
export function SiteSettingsProvider({
  value,
  children
}: {
  value: SiteSettings;
  children: React.ReactNode;
}) {
  return <SiteSettingsContext.Provider value={value} data-id="element-364" data-mp="305qyiujls2nv">{children}</SiteSettingsContext.Provider>;
}
export function useSiteSettings(): SiteSettings {
  return useContext(SiteSettingsContext);
}